import ManageSubscription from './ManageSubscription.page';

export default ManageSubscription;